import { createContext, useContext } from 'react';

import type { Mode, StyleVariant } from '@/constants';

import type { ColorScheme, ThemeMap } from './types';
import type { ThemeSlug } from '@/types';

// --- Context Definition ---

export type ThemeContextValue = {
  /** The currently selected mode ('light', 'dark', or 'system') */
  mode: Mode;
  /** The resolved color scheme ('light' or 'dark') */
  colorScheme: ColorScheme;
  /** The specific theme value applied (e.g., 'light', 'dark-blue') */
  theme: ThemeSlug;
  /** The specific style variant applied (e.g., 'default', 'compact') */
  variant: StyleVariant;
  /** Function to change the mode */
  setMode: (mode: Mode) => void;
  /** Available themes for light/dark mode */
  themes: ThemeMap;
};

export const ThemeContext = createContext<ThemeContextValue | undefined>(
  undefined
);

export const useTheme = (): ThemeContextValue => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
